import { render, staticRenderFns } from "./CodeAddressTable.vue?vue&type=template&id=c313c6e0&"
import script from "./CodeAddressTable.vue?vue&type=script&lang=ts&"
export * from "./CodeAddressTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports